export enum ProductCategoryCodes {
  CELULAR = "CELULAR",
  INTERNET_E_MODEM = "INTERNET_E_MODEM",
  MONITORAMENTO_E_RASTREAMENTO = "MONITORAMENTO_E_RASTREAMENTO",
  CHIP = "CHIP"
}
